<template>
    <dv-digital-flop style="height: 30px;" ref="digitalRef" :config="digitalConfig">
    </dv-digital-flop>
</template>
<script>
import Vue from 'vue';
import { digitalFlop } from '@jiaminghi/data-view'
Vue.use(digitalFlop);
export default {
    name: "mDigitalFlop",
    props: {
        numberFixed: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            digitalConfig: {
                number: [0], // 默认数据
                textAlign: 'center', //位置
                toFixed:this.numberFixed,
                style: {
                    height: 10,
                    fontSize: 16, //文字大小
                    fill: '#3de7c9' //文字颜色
                },
                // formatter(number) {
                //     const numbers = number.toString().split('').reverse()
                //     const segs = []
                //     while (numbers.length) segs.push(numbers.splice(0, 3).join(''))
                //     return segs.join(',').split('').reverse().join('')
                // }
            },
        }
    },
    methods: {
        update(num){

			this.digitalConfig.number = [num]
			this.$refs.digitalRef.update()
        }
    },
}
</script>
<style lang="less" scoped></style>
